<template>
  <div class="home">
    <innerHeader v-if="!isMobile" :ind="2"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <!--cloumnId控制contentList  Tab的active -->
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="4"
          :cloumnId="cloumnId"
          v-if="!isMobile"
          class="bg"
        >
          <div slot="main_content">
            <div class="content_top">
              <div class="activity_Time_con">
                <DateTab
                  v-model="currentDay"
                  :date-list="dateList"
                  @change="getData"
                />
                <!-- <div class="calendar">
                  <div
                    :class="[
                      'calendarList',
                      currentDay === cal.date ? 'active' : '',
                    ]"
                    v-for="(cal, index) in dateList"
                    :key="index"
                    @click="getData(cal, index)"
                  >
                    <div class="date">{{ cal.date.slice(5, 10) }}</div>
                    <div class="week">{{ cal.shortWeekday }}</div>
                  </div>
                  <div @click="showDatePicker" class="more">
                    {{ $t('moreDates') }}
                  </div>
                  <date-picker
                    ref="datePickers"
                    @confirm="confirm"
                  ></date-picker>
                </div> -->
                <div class="activity_Time_list">
                  <div class="Time_list_top">
                    <div class="title_l">
                      <div class="title_l_in">
                        <span class="month">{{ currentDay.slice(5, 7) }}/</span>
                        <span class="day">{{ currentDay.slice(8, 10) }}</span>
                      </div>
                    </div>
                    <div class="title_r">{{ $t('listTheatreFestival') }}</div>
                  </div>
                  <div v-if="activityTimeList.length">
                    <div
                      class="Time_list_down"
                      v-html="activityTimeList[0].details.content"
                    ></div>
                    <!-- <ul>
                      <li>
                        <div class="time">时间</div>
                        <div class="name">剧目</div>
                      </li>
                      <li
                        v-for="(activity, index) in activityTimeList"
                        :key="index"
                      >
                        <div class="time">{{ activity.time }}</div>
                        <div class="name">{{ activity.name }}</div>
                      </li>
                    </ul>
                    <ul>
                      <li>
                        <div class="time">时间</div>
                        <div class="name">剧目</div>
                      </li>
                      <li
                        v-for="(activity, ind) in activityTimeList"
                        :key="ind"
                      >
                        <div class="time">{{ activity.time }}</div>
                        <div class="name">{{ activity.name }}</div>
                      </li>
                    </ul> -->
                  </div>

                  <div class="content_top" v-else>
                    <el-empty :description="$t('noData')"></el-empty>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </contentList>
        <AppcontentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="4"
          :cloumnId="cloumnId"
          v-if="isMobile"
          class="appbg"
        >
          <div slot="main_content">
            <div class="app_content_top">
              <div class="activity_Time_con padding_con">
                <DateTab
                  v-model="currentDay"
                  :date-list="dateList"
                  @change="getData"
                />
                <!-- <div class="calendar">
                  <div
                    :class="[
                      'calendarList',
                      currentDay == cal.date ? 'active' : '',
                    ]"
                    v-for="(cal, index) in dateList.slice(0, 5)"
                    :key="index"
                    @click="getData(cal, index)"
                  >
                    <div class="date">{{ cal.date.slice(5, 10) }}</div>
                    <div class="week">{{ cal.shortWeekday }}</div>
                  </div>
                  <div @click="showDatePicker" class="more">
                    {{ $t('moreDates') }}
                  </div>
                  <date-picker
                    ref="datePickers"
                    @confirm="confirm"
                  ></date-picker>
                </div> -->
                <div class="activity_Time_list">
                  <div class="Time_list_top">
                    <div class="title_l">
                      <div class="title_l_in">
                        <span class="month">{{ currentDay.slice(5, 7) }}/</span>
                        <span class="day">{{ currentDay.slice(8, 10) }}</span>
                      </div>
                    </div>
                    <div class="title_r">{{ $t('listTheatreFestival') }}</div>
                  </div>
                  <div v-if="activityTimeList.length">
                    <div class="Time_list_down">
                      <div v-html="activityTimeList[0].details.content"></div>
                    </div>
                  </div>
                  <div class="content_top" v-else>
                    <el-empty :description="$t('noData')"></el-empty>
                  </div>
                  <!-- <div class="Time_list_down">
                    <ul>
                      <li>
                        <div class="time">时间</div>
                        <div class="name">剧目</div>
                      </li>
                      <li
                        v-for="(activity, index) in activityTimeList"
                        :key="index"
                      >
                        <div class="time">{{ activity.time }}</div>
                        <div class="name">{{ activity.name }}</div>
                      </li>
                    </ul>
                  </div> -->
                </div>
              </div>
            </div>
          </div></AppcontentList
        >
        <!-- <paginations
          :current-page.sync="page.current"
          @current-change="currentChange"
          :page-size="page.size"
          :total="page.total"
        ></paginations> -->
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <innerAppFooter v-else />
  </div>
</template>

<script>
import datePicker from '@/components/date-picker.vue';
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import innerAppFooter from '@/components/innerAppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { themeTab } from '@/const';
import {
  getWeekDates,
  getDatetime,
  formatDateToYMD,
  getDateRange,
} from '@/utils/date.js';
import { fetchConentList } from '@/assets/api';
import { getColumnAll } from '@/const';
import DateTab from '@/components/DateTab';
export default {
  name: 'ThemeTime',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    innerAppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
    datePicker,
    DateTab,
  },
  data() {
    return {
      currentIndex: 0,
      page: { current: 1, size: 10, total: 20 },
      tabList: themeTab,
      cloumnId: null,
      show: false,
      dateList: [],
      currentDay: '',
      list: [],

      activityTimeList: [
        // { time: '16:00', name: '酒神' },
        // { time: '17:00', name: '躺平2.0' },
        // { time: '18:00', name: '酒神' },
        // { time: '19:00', name: '躺平2.0' },
        // { time: '20:00', name: '酒神' },
        // { time: '21:00', name: '躺平2.0' },
      ],
      cloumnList: [],
    };
  },
  mounted() {
    if (this.$route.query) {
      if (this.$route.query.cloumnId) {
        this.cloumnId = this.$route.query.cloumnId;
      }
    }
    // if (!this.isMobile) {
    //   this.dateList = getWeekDates(this.currentDay);
    // } else {
    //   this.dateList = getWeekDates(this.currentDay);
    // }
    // this.dateList = this.dateList.map((d) => {
    //   switch (d.shortWeekday) {
    //     case '周一':
    //       d.shortWeekday = this.$t('monday');
    //       return d;
    //     case '周二':
    //       d.shortWeekday = this.$t('tuesday');
    //       return d;
    //     case '周三':
    //       d.shortWeekday = this.$t('wednesday');
    //       return d;
    //     case '周四':
    //       d.shortWeekday = this.$t('thursday');
    //       return d;
    //     case '周五':
    //       d.shortWeekday = this.$t('friday');
    //       return d;

    //     case '周六':
    //       d.shortWeekday = this.$t('saturday');
    //       return d;
    //     case '周日':
    //       d.shortWeekday = this.$t('sunday');
    //       return d;
    //     default:
    //       break;
    //   }
    // });
    this.initShowTime();
    this.getColumnList();
  },
  methods: {
    initShowTime() {
      this.siteList = this.$store.state.siteList;
      this.siteValue = this.$store.state.siteValue;
      let siteName = '';
      this.siteList.map((s) => {
        if (s.id == this.siteValue) {
          siteName = s.keywords;
        }
      });
      const year = siteName && siteName.slice(0, 4);
      this.dateList = getDateRange(year);
      this.currentDay = this.dateList[0].date;
    },
    getColumnList() {
      const navObj = getColumnAll();
      this.cloumnList = navObj.headNav;
      this.getList(this.currentDay);
    },
    // 时间变化
    getData(time) {
      this.currentDay = time;
      this.getList(time);
    },
    //演出时间表
    getList(time) {
      let id = '';
      this.cloumnList.map((c) => {
        if (c.accessPath == '/theme') {
          c.subnav.map((cl) => {
            if (cl.accessPath == '/themeTime') {
              id = cl.id;
            }
          });
        }
      });
      const data = {
        columnIds: id,
        size: 6,
        current: 1,
        startTime: time + ' 00:00:00',
        endTime: time + ' 23:59:59',
      };
      fetchConentList(data).then((res) => {
        this.activityTimeList = res.records;
      });
    },
    showDatePicker() {
      this.$refs.datePickers.open();
    },
    confirm(time) {
      this.currentDay = formatDateToYMD(time.date);
      this.dateList = getWeekDates(this.currentDay);
      this.getList(this.currentDay);
      this.$refs.datePickers.cancle();
    },
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.path });
      // this.getList();
    },
    currentChange(e) {
      this.current = e;
      // this.getList();
    },
    toDetail(id) {
      this.$router.push({ path: `/newsDetail?id=${id}` });
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  .content_top {
    padding: 40px 0;
    .activity_Time_con {
      .calendar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1.25rem;

        .calendarList {
          border: solid 1px #d9d9d9;
          border-radius: 0.625rem;
          padding: 1.25rem 2rem;
          cursor: pointer;

          .date {
            color: #424451;
            font-size: 2rem;
            font-family: SourceHanSansCN-Medium;
          }
          .week {
            color: #aaaaaa;
            font-size: 1.75rem;
            text-align: center;
            max-width: 5.625rem;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          &.active {
            background: #424451;
            color: #fff;
            border: solid 1px #424451;
            .date {
              color: #fff;
            }
            .week {
              color: #fff;
            }
          }
        }
        .more {
          color: #414254;
          font-size: 1.25rem;
          text-align: left;
          writing-mode: vertical-lr; /* 垂直方向，从左到右 */
          cursor: pointer;
        }
      }
      .activity_Time_list {
        margin-top: 2.8125rem;
        .Time_list_top {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 2.4167rem;
          margin-bottom: 1.3333rem;
          .title_l {
            width: 7.4375rem;
            height: 4.5625rem;
            background: url('../../assets/img/homeimgs/activity_time_title.png')
              no-repeat left center/100% 100%;
            padding: 0 0.1667rem;
            box-sizing: border-box;
            .title_l_in {
              .month {
                color: #333333;
                font-size: 2.25rem;
              }
              .day {
                color: #333333;
                font-size: 3.125rem;
                font-family: SourceHanSansCN-Bold;
              }
            }
          }
          .title_r {
            font-size: 2.25rem;
            color: #333;
            font-family: SourceHanSansCN-Medium;
            margin-left: 0.8333rem;
          }
        }
        .Time_list_down {
          margin-top: 2.1667rem;
          display: flex;
          justify-content: space-between;
          ul {
            flex: 1;
            li {
              width: 100%;
              display: flex;
              align-items: center;
              border-bottom: solid 0.0833rem #c2c2c2;
              height: 3rem;

              .time {
                width: 40%;
                text-align: center;
              }
              .name {
                width: 60%;
                text-align: left;
              }
            }
            li:nth-child(odd) {
              background-color: rgba(194, 194, 194, 0.16); /* 浅灰色 */
            }
            &:nth-child(1) {
              margin-right: 1.25rem;
            }
          }
        }
      }
    }
  }
  .app_content_top {
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    padding: 2rem 0;
    .activity_Time_con {
      .calendar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1.25rem;

        .calendarList {
          border: solid 1px #d9d9d9;
          border-radius: 0.625rem;
          padding: 0.625rem;
          .date {
            color: #424451;
            font-size: 1.25rem;
          }
          .week {
            color: #aaaaaa;
            font-size: 1.0833rem;
            font-family: SourceHanSansCN-Medium;
            text-align: center;
          }
          &.active {
            background: #424451;
            color: #fff;
            border: solid 1px #424451;
            .date {
              color: #fff;
            }
            .week {
              color: #fff;
            }
          }
        }
        .more {
          color: #777777;
          font-size: 0.8333rem;
          text-align: center;
          writing-mode: vertical-lr; /* 垂直方向，从左到右 */
        }
      }
      .activity_Time_list {
        .Time_list_top {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 2.4167rem;
          margin-bottom: 1.3333rem;
          .title_l {
            width: 4.6667rem;
            height: 2.4167rem;
            background: url('../../assets/img/appImg/activity_time_title.png')
              no-repeat left center/100% 100%;
            padding: 0 0.1667rem;
            box-sizing: border-box;
            .title_l_in {
              .month {
                color: #333333;
                font-size: 1.1667rem;
              }
              .day {
                color: #333333;
                font-size: 2rem;
                font-family: SourceHanSansCN-Bold;
              }
            }
          }
          .title_r {
            height: 2.4167rem;
            font-size: 1.1667rem;
            color: #333;
            font-family: SourceHanSansCN-Medium;
            margin-top: 1.5rem;
            margin-left: 0.8333rem;
          }
        }
        .Time_list_down {
          margin-top: 2.1667rem;
          ul {
            li {
              width: 100%;
              display: flex;
              align-items: center;
              border-bottom: solid 0.0833rem #c2c2c2;
              height: 3rem;

              .time {
                width: 40%;
                text-align: center;
              }
              .name {
                width: 60%;
                text-align: left;
              }
            }
            li:nth-child(odd) {
              background-color: rgba(194, 194, 194, 0.16); /* 浅灰色 */
            }
          }
        }
      }
    }
  }
}
::v-deep {
  .content_top {
    .el-empty {
      padding: 0.625rem 0;
      .el-empty__image {
        width: 40% !important;
      }
      .el-empty__description {
        font-size: 0.75rem !important;
      }
    }
  }
}
.appbg {
  width: 100%;
  // background: url('../../assets/img/appImg/presi_bg.png') no-repeat left
  //   bottom/100% auto;
  background: #fff;
}
.bg {
  width: 100%;
  // background: url('../../assets/img/homeimgs/article_bg.png') no-repeat left
  //   bottom/100% auto;
  background: url('../../assets/img/homeimgs/article_bg.png') fixed;
}
</style>
